

<mce-info-message [type]="viewState().boxType">

    @if(viewState().loading) {
    <div>loading...</div>
    }

    @if(!viewState().loading) {
    <div><ng-content></ng-content></div>
    }

    @if(viewState().isWarning || viewState().isError) {
    <div>{{viewState().message}}</div>
    }

</mce-info-message>

